// src/components/ProtectedRoute.tsx

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute: React.FC = () => {
  // ✅ SỬA LẠI: Sử dụng logic giống hệt PublicRoute.tsx
  const isAuthenticated = (): boolean => {
    const userString = sessionStorage.getItem('user'); // <-- Thay đổi từ localStorage sang sessionStorage
    if (!userString) return false;
    try {
      const user = JSON.parse(userString);
      return !!user.accessToken; // <-- Kiểm tra accessToken để chắc chắn hơn
    } catch (error) {
      console.error("Lỗi khi đọc dữ liệu session:", error);
      return false;
    }
  };

  // Nếu đã đăng nhập, cho phép render các trang con.
  // Nếu chưa, chuyển hướng về trang /login.
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;